import { createSlice } from "@reduxjs/toolkit";
import { fetchBuildings } from "./buildingsSlice";

const initialState = {
  currentPage: 1,
  rowsPerPage: 10,
  totalPages: 1,
};

const buildingsPaginationSlice = createSlice({
  name: "buildingsPagination",
  initialState,
  reducers: {
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setRowsPerPage: (state, action) => {
      state.rowsPerPage = action.payload;
    },
    setTotalPages: (state, action) => {
      state.totalPages = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchBuildings.fulfilled, (state, action) => {
      state.totalPages = action.payload.totalPages;
    });
  },
});

export const { setCurrentPage, setRowsPerPage, setTotalPages } =
  buildingsPaginationSlice.actions;

export const selectCurrentPage = (state) =>
  state.buildingsPagination.currentPage;
export const selectTotalPages = (state) => state.buildingsPagination.totalPages;
export const selectRowsPerPage = (state) =>
  state.buildingsPagination.rowsPerPage;

export default buildingsPaginationSlice.reducer;
